import React from 'react';
import { PapiDeviation } from '@wix/da-types-papi';
import FreeformHugeThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Huge/Freeform';

export interface Props {
  item: PapiDeviation;
  className?: string;
}

export class JournalItem extends React.Component<Props> {
  render() {
    const { item, className } = this.props;
    return <FreeformHugeThumb className={className} deviation={item} />;
  }
}

export default JournalItem;
